module.exports = __webpack_public_path__ + "img/_logo_header@2x.24eb652c.png";